export const SearchIcon = ({
  className = 'w-4 h-4',
}: {
  className?: string;
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4583 10.0833H10.7342L10.4775 9.83583C11.3758 8.79083 11.9167 7.43417 11.9167 5.95833C11.9167 2.6675 9.24917 0 5.95833 0C2.6675 0 0 2.6675 0 5.95833C0 9.24917 2.6675 11.9167 5.95833 11.9167C7.43417 11.9167 8.79083 11.3758 9.83583 10.4775L10.0833 10.7342V11.4583L14.6667 16.0325L16.0325 14.6667L11.4583 10.0833ZM5.95833 10.0833C3.67583 10.0833 1.83333 8.24083 1.83333 5.95833C1.83333 3.67583 3.67583 1.83333 5.95833 1.83333C8.24083 1.83333 10.0833 3.67583 10.0833 5.95833C10.0833 8.24083 8.24083 10.0833 5.95833 10.0833Z"
      fill="currentColor"
    />
  </svg>
);
